import { takeLatest, put, call } from 'redux-saga/effects'

import {
  EXTEND_REFERRAL_SUCCESS,
  EXTEND_REFERRAL_FAILURE,
  EXTEND_REFERRAL,
} from '../constants/constant.action'
import { api } from '../services'

function* getExtendReferralSaga(action) {
  try {
    const result = yield call(api.getExtendReferralRequest, action.payload)
    yield put({ type: EXTEND_REFERRAL_SUCCESS, payload: result.data })
  } catch (error) {
    yield put({ type: EXTEND_REFERRAL_FAILURE, error })
  }
}

export function* extendReferralWatcherSaga() {
  yield takeLatest(EXTEND_REFERRAL, getExtendReferralSaga)
}
